(function () {
  var SECTION_SELECTOR = '.oddit-section-archive-carousel';
  var TRACK_SELECTOR = '.oddit-section-archive-carousel__track';
  var CARD_SELECTOR = '.oddit-section-archive-carousel__card';
  var DOT_SELECTOR = '.oddit-section-archive-carousel__dot';
  var PREV_SELECTOR = '.oddit-section-archive-carousel__arrow--prev';
  var NEXT_SELECTOR = '.oddit-section-archive-carousel__arrow--next';
  var ACTIVE_CLASS = 'oddit-section-archive-carousel__card--active';
  var DOT_ACTIVE_CLASS = 'oddit-section-archive-carousel__dot--active';

  var cloneSeq = 0;

  function sanitizeClone(node, suffix) {
    node.setAttribute('aria-hidden', 'true');
    node.classList.remove(ACTIVE_CLASS);

    var all = [node].concat(Array.prototype.slice.call(node.querySelectorAll('*')));
    var idMap = {};

    all.forEach(function (el) {
      var id = el.getAttribute && el.getAttribute('id');
      if (id) {
        idMap[id] = id + '-' + suffix;
        el.setAttribute('id', idMap[id]);
      }
    });

    all.forEach(function (el) {
      if (el.attributes) {
        Array.prototype.slice.call(el.attributes).forEach(function (attr) {
          if (attr.value.indexOf('url(#') === -1) return;
          var value = attr.value;
          Object.keys(idMap).forEach(function (old) {
            value = value.split('url(#' + old + ')').join('url(#' + idMap[old] + ')');
          });
          el.setAttribute(attr.name, value);
        });
      }

      el.removeAttribute('data-card-index');
      el.removeAttribute('data-setting-id');

      if (typeof el.className === 'string' && el.className.indexOf('oddit-reveal') !== -1) {
        el.className = el.className
          .split(/\s+/)
          .filter(function (c) { return c.indexOf('oddit-reveal') !== 0; })
          .join(' ');
        el.style.opacity = '';
        el.style.transform = '';
      }

      if (el.matches && el.matches('a, button, input, select, textarea, [tabindex]')) {
        el.setAttribute('tabindex', '-1');
      }
    });

    return node;
  }

  function initSection(section) {
    var track = section.querySelector(TRACK_SELECTOR);
    var reals = Array.prototype.slice.call(section.querySelectorAll(CARD_SELECTOR));
    var dots = Array.prototype.slice.call(section.querySelectorAll(DOT_SELECTOR));
    var prevBtn = section.querySelector(PREV_SELECTOR);
    var nextBtn = section.querySelector(NEXT_SELECTOR);

    if (!track || reals.length === 0) return;

    var N = reals.length;
    var firstReal = reals[0];

    if (N > 1) {
      reals.forEach(function (card) {
        track.insertBefore(sanitizeClone(card.cloneNode(true), 'lead' + ++cloneSeq), firstReal);
      });
      reals.forEach(function (card) {
        track.appendChild(sanitizeClone(card.cloneNode(true), 'trail' + ++cloneSeq));
      });
    }

    var slides = Array.prototype.slice.call(track.querySelectorAll(CARD_SELECTOR));
    var currentDom = N > 1 ? N + 1 : 0;
    var isAdjusting = false;
    var adjustToken = 0;
    var navigating = false;
    var userHasTakenControl = false;
    var autoplayState = null;

    function centerOffset() {
      var cardW = slides[0] ? slides[0].offsetWidth : 0;
      return (track.clientWidth - cardW) / 2;
    }

    function posOf(domIndex) {
      if (!slides[domIndex]) return 0;
      return slides[domIndex].offsetLeft - centerOffset();
    }

    function nearestDom() {
      var center = track.scrollLeft + centerOffset();
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var dist = Math.abs(slides[i].offsetLeft - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function logicalIndex(domIndex) {
      if (N < 2) return 0;
      return ((domIndex - N) % N + N) % N;
    }

    function updateActive() {
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle(ACTIVE_CLASS, i === currentDom);
      }
      var logical = logicalIndex(currentDom);
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle(DOT_ACTIVE_CLASS, j === logical);
        dots[j].setAttribute('aria-selected', j === logical ? 'true' : 'false');
      }
    }

    function setScrollInstant(pos) {
      isAdjusting = true;
      var token = ++adjustToken;
      var snap = track.style.scrollSnapType;
      var behavior = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = pos;
      requestAnimationFrame(function () {
        track.style.scrollSnapType = snap;
        track.style.scrollBehavior = behavior;
        requestAnimationFrame(function () {
          if (token !== adjustToken) return;
          isAdjusting = false;
          updateActive();
        });
      });
    }

    function scrollToDom(domIndex) {
      if (domIndex < 0) domIndex = 0;
      if (domIndex > slides.length - 1) domIndex = slides.length - 1;
      currentDom = domIndex;
      navigating = true;
      track.scrollTo({ left: posOf(domIndex), behavior: 'smooth' });
      updateActive();
    }

    function isDragging() {
      return track.classList.contains('is-dragging');
    }

    function normalize() {
      if (isAdjusting || isDragging() || N < 2) {
        updateActive();
        return;
      }
      var nearest = nearestDom();
      currentDom = nearest;
      var normalized = nearest;
      if (nearest < N) normalized = nearest + N;
      else if (nearest >= 2 * N) normalized = nearest - N;
      if (normalized !== nearest) {
        currentDom = normalized;
        track.classList.add('is-looping');
        setScrollInstant(posOf(normalized));
        updateActive();
        void track.offsetHeight;
        track.classList.remove('is-looping');
      }
      navigating = false;
      updateActive();
    }

    var settleTimer = null;
    var scrollRaf = null;

    track.addEventListener('scroll', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(normalize, 140);
      if (isAdjusting || navigating || scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        if (isAdjusting) return;
        currentDom = nearestDom();
        updateActive();
      });
    }, { passive: true });

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', normalize);
    }

    function disableAutoplayPermanently() {
      if (userHasTakenControl) return;
      userHasTakenControl = true;
      if (autoplayState) autoplayState.stop();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        disableAutoplayPermanently();
        scrollToDom(currentDom - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        disableAutoplayPermanently();
        scrollToDom(currentDom + 1);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        disableAutoplayPermanently();
        scrollToDom(N + i);
      });
    });

    track.addEventListener('pointerdown', disableAutoplayPermanently);
    track.addEventListener('touchstart', disableAutoplayPermanently, { passive: true });
    track.addEventListener('wheel', disableAutoplayPermanently, { passive: true });
    track.addEventListener('focusin', disableAutoplayPermanently);

    /* Listeners stored for teardown */
    var visibilityHandler = null;
    var reducedMotionHandler = null;
    var trackMouseEnter = null;
    var trackMouseLeave = null;

    var autoplayEnabled = section.dataset.autoplay === 'true';
    if (autoplayEnabled) {
      var speedSeconds = parseInt(section.dataset.autoplaySpeed, 10) || 5;
      var intervalMs = speedSeconds * 1000;
      var timerId = null;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      var startAutoplay = function () {
        if (userHasTakenControl || timerId || reducedMotion.matches || document.hidden) return;
        timerId = setInterval(function () {
          scrollToDom(currentDom + 1);
        }, intervalMs);
      };

      var stopAutoplay = function () {
        clearInterval(timerId);
        timerId = null;
      };

      autoplayState = { start: startAutoplay, stop: stopAutoplay };

      visibilityHandler = function () {
        if (userHasTakenControl) return;
        document.hidden ? stopAutoplay() : startAutoplay();
      };
      document.addEventListener('visibilitychange', visibilityHandler);

      trackMouseEnter = function () {
        if (!userHasTakenControl) stopAutoplay();
      };
      trackMouseLeave = function () {
        if (!userHasTakenControl) startAutoplay();
      };
      track.addEventListener('mouseenter', trackMouseEnter);
      track.addEventListener('mouseleave', trackMouseLeave);

      reducedMotionHandler = function () {
        stopAutoplay();
        startAutoplay();
      };
      reducedMotion.addEventListener('change', reducedMotionHandler);

      startAutoplay();
    }

    var resizeTimer = null;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setScrollInstant(posOf(currentDom));
        updateActive();
      }, 150);
    }
    window.addEventListener('resize', onResize);

    updateActive();
    setScrollInstant(posOf(currentDom));
    requestAnimationFrame(function () {
      setScrollInstant(posOf(currentDom));
    });

    section._odditTeardown = function () {
      if (autoplayState) autoplayState.stop();
      window.removeEventListener('resize', onResize);
      if (visibilityHandler) document.removeEventListener('visibilitychange', visibilityHandler);
      if (reducedMotionHandler && window.matchMedia) {
        window.matchMedia('(prefers-reduced-motion: reduce)').removeEventListener('change', reducedMotionHandler);
      }
      if (trackMouseEnter) track.removeEventListener('mouseenter', trackMouseEnter);
      if (trackMouseLeave) track.removeEventListener('mouseleave', trackMouseLeave);
      clearTimeout(settleTimer);
      clearTimeout(resizeTimer);
      cancelAnimationFrame(scrollRaf);
    };
  }

  function destroySection(section) {
    if (section && section._odditTeardown) {
      section._odditTeardown();
      section._odditTeardown = null;
    }
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
